import { HTMLAttributes } from 'react'

import cn from '@/utils/tailwind/cn'

export const IntegrationCardFooter = ({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'flex justify-end space-x-2 border-t border-gray-200 bg-gray-50 p-3',
      className
    )}
    {...props}
  />
)
